import React from 'react';

export default function SplashScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-orange-500 to-orange-900">
      <div className="relative w-64 h-64 flex items-center justify-center">
        {/* Background plate image with blur effect */}
        <div 
          className="absolute inset-0 bg-center bg-cover rounded-full opacity-20 blur-lg"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1547592180-85f173990554?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80)'
          }}
        />
        
        {/* Logo */}
        <img 
          src="/logo-blanc.png"
          alt="Kaswila Logo"
          className="w-48 h-auto relative z-10"
        />
      </div>
      
      {/* Wooden spoon image */}
      <img 
        src="https://raw.githubusercontent.com/kaswila/assets/main/wooden-spoon.png"
        alt="Wooden Spoon"
        className="w-24 h-auto mt-8"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = '/wooden-spoon.png';
        }}
      />
      
      {/* Loading bar */}
      <div className="w-48 h-1 bg-white/20 rounded-full mt-12 overflow-hidden">
        <div className="h-full bg-white rounded-full animate-[loading_2s_ease-in-out_infinite]" />
      </div>
    </div>
  );
}